module.exports = __webpack_public_path__ + "e1e2f7eb6c1a3cc5f118ec8a91d0364c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/public/img/washs/wash-6.jpg
// module id = 80
// module chunks = 0